import { defineStore } from "pinia";
import { ref } from "vue";
import { cmsApi } from "@/api/cms";

export const useSiteConfigStore = defineStore("siteConfig", () => {
  const config = ref<any>({
    siteName: "MIER",
    siteLogo: "/images/logo.svg",
    contactPhone: "",
    contactEmail: "",
    contactAddress: "",
    icpNumber: "",
    copyright: "",
    aboutUs: "",
    statsData: "{}",
  });

  const loading = ref(false);

  const fetchConfig = async () => {
    loading.value = true;
    try {
      const res: any = await cmsApi.getSiteConfig();
      if (res && res.data) {
        config.value = { ...config.value, ...res.data };
      }
    } catch (error) {
    } finally {
      loading.value = false;
    }
  };

  return {
    config,
    loading,
    fetchConfig,
  };
});
